import {OlivioSistemaLuminaire} from './olivioSistemaLuminaire';
import {OlivioFloracionLuminaire} from './olivioFloracionLuminaire';
import {OlivioCandelabraLuminaire} from './olivioCandelabraLuminaire';
import {OlivioBollardLuminaire} from './olivioBollardLuminaire';
import {OlivioUniversalLuminaire} from './olivioUniversalLuminaire';

const olivioLuminaires = {
	sistema: OlivioSistemaLuminaire,
	floracion: OlivioFloracionLuminaire,
	candelabra: OlivioCandelabraLuminaire,
	bollard: OlivioBollardLuminaire,
	universal: OlivioUniversalLuminaire,
};


export {olivioLuminaires};
